export default __webpack_public_path__ + "static/media/step-3-fr.9f967b49.svg";